import { render, staticRenderFns } from "./maps-point.vue?vue&type=template&id=501b3a48&scoped=true"
import script from "./maps-point.vue?vue&type=script&lang=js"
export * from "./maps-point.vue?vue&type=script&lang=js"
import style0 from "./maps-point.vue?vue&type=style&index=0&id=501b3a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b3a48",
  null
  
)

export default component.exports